module.exports = __webpack_public_path__ + "static/daily-activity-1-81e33fa669f8dedfa6cbbb9d5da250dd.png";